<template>
  <div>
    <v-toolbar height="80%" color="#FF6F00">
      <v-toolbar-title>
        <v-img
          class="mx-3"
          @click="goTo('/')"
          src="../assets/img/logo1.png"
          height="auto"
          width="auto"
        ></v-img>
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer> -->
      <v-text-field
        class="search"
        hide-details
        v-model="cari"
        label="Cari Produk"
        v-on:keyup.13="find()"
        prepend-inner-icon="fas fa-search"
        solo
        dense
        flat
      ></v-text-field>
      <v-btn @click="goTo('/cart')" style="float:right;" dark icon>
        <v-badge
          :content="cartHeader"
          bordered
          :value="cartHeader"
          color="green"
          overlap
        >
          <v-icon size="25">fas fa-shopping-cart</v-icon>
        </v-badge>
      </v-btn>
      <v-divider vertical light></v-divider>
      <v-chip
        v-if="userid != null"
        class="ma-2"
        color="white"
        text-color="black"
      >
        <v-avatar left>
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>
        {{ dataUser.nama }}
      </v-chip>
    </v-toolbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      overlay: false,
      cari: "",
      email: "",
      password: "",
      carts: [],
      dataUser: [],
      cartHeader: 0,

      valid: true,
      PassRules: [(v) => !!v || "Pass is required"],
      EmailRules: [(v) => !!v || "Email is required"],
      userid: localStorage.getItem("user_id"),
      idkeranjang: localStorage.getItem("idkeranjang"),
      items: [
        { icon: "fas fa-list", text: "Produk", route: "/product" },

        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Tagihan & Keuangan",
          model: false,
          children: [
            { text: "Pulsa", route: "/coming" },
            { text: "Listrik", route: "/coming" },
            { text: "PAM", route: "/coming" },
            { text: "BPJS", route: "/coming" },
            { text: "Pajak Tahunan", route: "/coming" },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Tiket",
          model: false,
          children: [
            { text: "Tiket Pesawat", route: "/coming" },
            { text: "Tiket Kereta", route: "/coming" },
            { text: "Tiket Bus", route: "/coming" },
          ],
        },
        { icon: "fas fa-cart-arrow-down", text: "Keranjang", route: "/cart" },
        { icon: "fas fa-address-card", text: "Akun", route: "/account/0" },
      ],
    };
  },
  mounted() {
    if (this.userid != null) {
      this.getCart();
      this.getDataUser();
    }
  },
  methods: {
    goTo(e) {
      this.$router.push(e);
    },
    getCart() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkoutpro/" +
          this.idkeranjang +
          "/1000"
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.keranjang != null) {
            this.carts = data.keranjang;
            var x = this.carts.length;
            if (x > 0) {
              this.cartHeader = x;

              this.notifCart = x;
            } else {
              this.cartHeader = 0;
            }

            this.overlay = false;
          } else {
            this.cartHeader = 0;
            this.overlay = false;
          }
        });
    },
    getDataUser() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/ViewUser/" +
          localStorage.getItem("user_id")
      )
        .then((response) => response.json())
        .then((data) => {
          this.dataUser = data;
        });
    },
    SignIn() {
      this.loading = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/Login", {
        method: "POST",
        body: JSON.stringify({ email: this.email, password: this.password }),
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          
          this.loading = false;

          if (data.token != null) {
            Swal.fire(
              "Berhasil !",
              "Selamat Datang di Smartclub247",
              "success"
            );
            localStorage.setItem("idkeranjang", data.keranjang);
            localStorage.setItem("token", data.token);
            parseInt(localStorage.setItem("user_id", data.id));
            localStorage.setItem("alamat_id", data.alamat_id);
            this.dialog = false;

            window.location.reload();
          } else {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: "Periksa Kembali Email dan Password Anda",
            });
          }
        });
    },

    SignOut() {
      this.overlay = true;
      Swal.fire({
        title: "Anda Yakin ?",
        text: "Anda perlu login untuk belanja kembali",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Lanjutkan",
      }).then((result) => {
        if (result.value) {
          localStorage.clear();
          window.location.reload();
          Swal.fire("Logout!", "Anda telah keluar.", "success");
        }
      });

      this.overlay = false;
    },
  },
};
</script>
<style scoped>
.welcome-text {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: white;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: small-caps;
  text-transform: none;
}
@media only screen and (max-width: 768px) {
  .login-btn {
    display: none;
  }
}
</style>
